import "./MechanicalBullBuyingGuide.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BuyerCriteria from "./sections/BuyerCriteria";
import OperatingGuide from "./sections/OperatingGuide";
import Decide from "./sections/Decide";
import ElectricBull from "./sections/ElectricBull";
import Arenas from "./sections/Arenas";
import Controller from "./sections/Controller";
import CheckPackage from "./sections/CheckPackage";
import SitePreparationChecklist from "./sections/Sitepreparationchecklist";
import SafetyReview from "./sections/SafetyReview";
import ReplacementParts from "./sections/ReplacementParts";
import CompareValue from "./sections/CompareValue";
import Procurement from "./sections/Procurement";
import Checklist from "./sections/Checklist";
import BuyingFaq from "./sections/BuyingFaq";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function MechanicalBullBuyingGuidePage() {
  return <div>
      <Header />
      <Hero />
      <BuyerCriteria />
      <OperatingGuide />
      <Decide />
      <ElectricBull />
      <Arenas />
      <Controller />
      <CheckPackage />
      <SitePreparationChecklist />
      <SafetyReview />
      <ReplacementParts />
      <CompareValue />
      <Procurement />
      <Checklist />
      <BuyingFaq />
      <Cta />
      <Footer />
    </div>;
}